import { render, staticRenderFns } from "./AdminVideoList.vue?vue&type=template&id=b9824cf0&scoped=true"
import script from "./AdminVideoList.vue?vue&type=script&lang=js"
export * from "./AdminVideoList.vue?vue&type=script&lang=js"
import style0 from "./AdminVideoList.vue?vue&type=style&index=0&id=b9824cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9824cf0",
  null
  
)

export default component.exports